import React from "react";
import Link from "gatsby-link";
import Helmet from "react-helmet";
import favicon16 from "../img/favicon/16x16.png";
import favicon32 from "../img/favicon/32x32.png";
import favicon64 from "../img/favicon/64x64.png";
// import {
//   FaLinkedin,
//   FaEnvelope,
//   FaKey,
//   FaSkype,
//   FaMapMarker
// } from "react-icons/fa";

// data
import data from "../data.json";

// Styles
import "../scss/plain.scss";

class PlainLayout extends React.Component {
  static childContextTypes = {
    reactIconBase: function() {}
  };

  getChildContext() {
    return {
      reactIconBase: {
        size: 20
      }
    };
  }

  render() {
    return (
      <div id="plain">
        <Helmet
          title="Bernie Graham"
          meta={[
            {
              name: "description",
              content:
                "Bernie Graham - Sr. Software Engineer and Engineering Manager"
            },
            {
              name: "keywords",
              content: "Scala, go, golang, python, aws"
            }
          ]}
          link={[
            {
              rel: "icon",
              type: "image/png",
              sizes: "16x16",
              href: `${favicon16}`
            },
            {
              rel: "icon",
              type: "image/png",
              sizes: "32x32",
              href: `${favicon32}`
            },
            {
              rel: "shortcut icon",
              type: "image/png",
              href: `${favicon64}`
            }
          ]}
        />
        <div id="head">
          <div>
            <h1>{data.name}</h1>
            {this.props.showMenu && (
              <ul>
                <li>
                  <Link to="/about">about</Link>
                </li>
                <li>
                  <Link to="/resume">resume</Link>
                </li>
              </ul>
            )}
          </div>
          <hr />
          <div className="links">
            {/* <a href="mailto:bernie@berniegraham.com">
              <FaEnvelope />
            </a>
            <a
              href="https://keybase.io/berniegraham"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaKey />
            </a>
            <a href="skype:bernie-graham">
              <FaSkype />
            </a>
            <a
              href="https://www.linkedin.com/in/bernie-graham"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin />
            </a>
            <a
              href="https://goo.gl/maps/c5F5EjErBAG2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaMapMarker />
            </a> */}
          </div>
        </div>
        <div id="main">{this.props.children}</div>
      </div>
    );
  }
}

PlainLayout.defaultProps = {
  showMenu: true
};

export default PlainLayout;



// WEBPACK FOOTER //
// ./src/layouts/plain.js